import api from './api';

export interface TextTranslationRequest {
  text: string;
  sourceLanguage?: string;
  targetLanguage: string;
}

export interface TextTranslationResult {
  translatedText: string;
  sourceLanguage: string;
  targetLanguage: string;
  providerUsed: string;
}

export interface TextTranslationJob {
  jobId: string;
  title?: string;
  status: 'pending' | 'processing' | 'completed' | 'failed';
  progress: number;
  currentStep: string;
  request: TextTranslationRequest & { provider?: 'deepl' | 'google' };
  result?: TextTranslationResult;
  error?: string;
  createdAt: string;
}

export const textTranslationApi = {
  translate: (data: { text: string; title?: string; sourceLanguage?: string; targetLanguage: string; provider?: 'deepl' | 'google' }) =>
    api.post<{ success: boolean; message: string; data: { jobId: string; status: string; progress: number; currentStep: string; title?: string } }>(
      '/text-translation',
      data
    ),

  getJobs: (params?: { page?: number; limit?: number }) =>
    api.get<{ success: boolean; data: { jobs: TextTranslationJob[]; pagination: { page: number; limit: number; total: number; pages: number } } }>(
      '/text-translation/jobs',
      { params }
    ),

  getJob: (jobId: string) =>
    api.get<{ success: boolean; data: TextTranslationJob }>(`/text-translation/${jobId}`),

  retryJob: (jobId: string) =>
    api.post<{ success: boolean; data: { jobId: string; status: string } }>(`/text-translation/${jobId}/retry`),
};
